import { createTranslations } from '@npco/utils-translations'

export const transactionDetailsInfoTranslations = createTranslations({
  account: 'Account',
  description: 'Description',
  reference: 'Reference',
  downloadRemittance: 'Download Remittance',
  remittanceDownloaded: 'Remittance Downloaded',
})
